import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

const SelectorInput = (props) => {
  const { options, multiple, value, placeholder, onChange, onSearchChange } = props;
  const [search, setSearch] = useState('');

  const handleDropdownChange = (event, data) => {
    setSearch('');
    onChange(event, data);
  };

  const handleSearchChange = (event, data) => {
    setSearch(data.searchQuery);
    if (typeof onSearchChange === 'function') {
      onSearchChange(event, data);
    }
  };

  const handlePaste = (event) => {
    if (!multiple) return;
    const pasted = event.clipboardData.getData('Text');
    if (!pasted) return;

    const pastedTitles = pasted
      .split(/\s+/)
      .map((t) => t.trim())
      .filter(Boolean);

    // Check if option.text and pastedtitle are valid, and check for partial matches for both.
    const matchedValues = options
      .filter((opt) =>
        pastedTitles.some(
          (title) => opt.text && title && opt.text.toLowerCase().includes(title.toLowerCase())
        )
      )
      .map((opt) => opt.value);

    if (matchedValues.length > 0) {
      // If value is an array, merge with matched values, otherwise create a new array
      let newValue = Array.isArray(value) ? [...value] : value ? [value] : [];
      // Ensure newValue is unique by using Set
      newValue = Array.from(new Set([...newValue, ...matchedValues]));
      // Set selection with the new value
      onChange(null, { ...props, value: newValue });
      event.preventDefault();
    }
  };

  return (
    <div onPaste={handlePaste}>
      <Dropdown
        placeholder={placeholder}
        fluid
        multiple={multiple}
        search
        searchQuery={search}
        selection
        value={value}
        options={options}
        onChange={handleDropdownChange}
        onSearchChange={handleSearchChange}
      />
    </div>
  );
};

SelectorInput.propTypes = {
  placeholder: PropTypes.string,
  accessor: PropTypes.string,
  formInput: PropTypes.object,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      text: PropTypes.string,
    })
  ),
  value: PropTypes.string,
  multiple: PropTypes.bool,
  onSearchChange: PropTypes.func,
};

SelectorInput.defaultProps = {
  onChange: () => {},
  options: [],
  multiple: true,
  value: null,
  onSearchChange: null,
};

export default SelectorInput;
